import React from "react";
import { ChatState } from "../../../../../contexts/chatProvider";
import { Tooltip, Avatar } from "@chakra-ui/react";
import ScrollableFeed from "react-scrollable-feed";
import {
  isSameSender,
  isLastMessage,
  isSameSenderMargin,
  isSameUser,
} from "../../../../../config/ChatLogix";

const ScrollableChat = ({ messages }) => {
  console.log("messages", messages);
  const { user } = ChatState();

  return (
    <ScrollableFeed style={{ maxWidth: "100%" }}>
      {messages
        .filter(m => m && m._id && m.sender && m.sender._id && m.content)
        .map((m, i) => (
          <div style={{ display: "flex", maxWidth: "100%" }} key={m._id}>
            {(isSameSender(messages, m, i, user._id) ||
              isLastMessage(messages, i, user._id)) && (
              <Tooltip label={m.sender.name} placement="bottom-start" hasArrow>
                <Avatar
                  size="sm"
                  mt="7px"
                  mr={1}
                  cursor="pointer"
                  name={m.sender.name}
                  src={m.sender.pic}
                />
              </Tooltip>
            )}
            <span
              style={{
                backgroundColor: `${
                  m.sender._id === user._id ? "lightgreen" : "skyblue"
                }`,
                borderRadius: "20px",
                padding: "5px 15px",
                maxWidth: "75%",
                marginLeft: isSameSenderMargin(messages, m, i, user._id),
                marginTop: isSameUser(messages, m, i, user._id) ? 3 : 10,
              }}
            >
              {m.content}
            </span>
          </div>
        ))}
    </ScrollableFeed>
  );
};
export default ScrollableChat;
